import React, { FC } from 'react';

import useChargesKMLN from '../services/useGetChargesKM';
import ChargesKMScene from './charges-km-scene';

interface Props {
  showHeaderAndContainer?: boolean;
}

const ChargesKM: FC<Props> = ({ showHeaderAndContainer = true }) => {
  const {
    dataCharges,
    handleDelete,
    handleEditModal,
    openAddModal,
    handleAddModal,
    reloadAccounting,
    state,
  } = useChargesKMLN(['K', 'M']);

  return (
    <ChargesKMScene
      accountingData={dataCharges || []}
      handleDelete={handleDelete}
      handleEditModal={handleEditModal}
      openAddModal={openAddModal}
      handleaddModal={handleAddModal}
      reloadAccounting={reloadAccounting}
      state={state as any}
      showHeaderAndContainer={showHeaderAndContainer}
    />
  );
};

export default ChargesKM;
